import React from 'react';
import { Divider, Flex, RemoteImage, Typography } from '@banhala/ui-kit';
import { useGoodsModelInfo } from '../queries/useGoodsModelInfo';
import { isNil } from 'shared/src/utils';

function numeric(str: string): number {
  return parseInt(str, 10);
}

const SIZE_ITEMS = [
  { key: 'height', label: '키' },
  { key: 'top', label: '상의' },
  { key: 'bottom', label: '하의' },
  { key: 'shoes', label: '신발' },
] as const;

export const ModelInfo: React.FC = () => {
  const { data: modelInfo } = useGoodsModelInfo();

  if (isNil(modelInfo)) return null;

  return (
    <Flex>
      <Divider size="small" />
      <Flex padding={{ horizontal: 16 }}>
        <Flex padding={{ vertical: 20 }}>
          <Typography type={'h5'} color={'content_primary'}>
            MODEL INFO
          </Typography>
        </Flex>
        <Flex.Row padding={{ left: 8, right: 24, bottom: 20 }}>
          <Flex
            width={80}
            height={80}
            borderRadius={6}
            overflow={'hidden'}
            margin={{ right: 24 }}
          >
            <RemoteImage
              uri={modelInfo.image}
              width={80}
              height={80}
              resizeMode="cover"
            />
          </Flex>
          <Flex flex={1} justifyContent={'center'}>
            <Typography type={'h5'} color={'content_primary'}>
              {modelInfo.name}
            </Typography>
            <Flex.Row
              justifyContent={'space-between'}
              padding={{ top: 12 }}
              gap={8}
            >
              {SIZE_ITEMS.map(({ key, label }) => {
                const value = modelInfo.size[key];
                if (isNil(value)) return null;
                return (
                  <Flex key={key} alignItems={'center'} gap={4}>
                    <Typography type={'h5'} color={'content_primary'}>
                      {numeric(value)}
                    </Typography>
                    <Typography type={'body4'} color={'content_secondary'}>
                      {label}
                    </Typography>
                  </Flex>
                );
              })}
            </Flex.Row>
          </Flex>
        </Flex.Row>
      </Flex>
    </Flex>
  );
};
